<template>
  <div>
    <v-row>
      <v-col class="pb-0">
        <label class="font-weight-bold">Coleção Atual: </label>
        <span></span>
      </v-col>
      <!-- <v-col class="pb-0">
            <label class="font-weight-bold">Fornecedor: </label>
            <span>0248 - PG4 IND CALÇADOS E ARTEF DE COURO LTDA</span>
          </v-col> -->
      <!-- <v-col class="pb-0">
            <label class="font-weight-bold">Coleção Atual: </label>
            <span>OUTONO INVERNO 2023</span>
          </v-col> -->
    </v-row>
    <v-row>
      <v-col class="pt-0 mt-0">
        <v-divider></v-divider>
      </v-col>
    </v-row>
    <v-row>
      <v-col></v-col>
      <v-col cols="2" class="d-flex justify-end">
        <v-btn
          outlined
          style="border-color: white"
          @click="() => (productColumns = 4)"
        >
          <v-icon :color="productColumns === 4 ? 'black' : 'grey'"
            >mdi-square-rounded-outline</v-icon
          >
          <v-icon :color="productColumns === 4 ? 'black' : 'grey'"
            >mdi-square-rounded-outline</v-icon
          >
          <v-icon :color="productColumns === 4 ? 'black' : 'grey'"
            >mdi-square-rounded-outline</v-icon
          >
        </v-btn>

        <v-btn
          outlined
          style="border-color: white"
          class="ms-1"
          @click="() => (productColumns = 3)"
        >
          <v-icon :color="productColumns === 3 ? 'black' : 'grey'"
            >mdi-square-rounded-outline</v-icon
          >
          <v-icon :color="productColumns === 3 ? 'black' : 'grey'"
            >mdi-square-rounded-outline</v-icon
          >
          <v-icon :color="productColumns === 3 ? 'black' : 'grey'"
            >mdi-square-rounded-outline</v-icon
          >
          <v-icon :color="productColumns === 3 ? 'black' : 'grey'"
            >mdi-square-rounded-outline</v-icon
          >
        </v-btn>
      </v-col>
      <v-col cols="2" class="d-flex justify-end">
        <v-select
          :items="ordenationOptions"
          v-model="ordenation"
          label="Ordenar Por"
          dense
          hide-details
          @change="handleChangeOrdenation()"
        ></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col
        class="d-flex child-flex"
        :cols="productColumns"
        v-for="(product, idx) in productsFilteredOrdened"
        :key="`${product.reference}${product.color_id}${product.material_id}_${idx}`"
      >
        <v-card
          class="elevation-0 card-product"
          @click="showDetailsProduct(product)"
        >
          <div class="wrapper-labels">
            <label v-if="product.marketing" class="mkt">MKT</label>
            <label v-if="product.opportunity" class="opportunity">
              OPORTUNIDADE
            </label>
          </div>
          <div class="wrapper-selos">
            <img
              v-for="selo in product.technologies"
              :key="selo.name"
              class="selo"
              :src="selo.image"
            />
          </div>
          <v-img
            :src="product.image"
            :lazy-src="product.image"
            aspect-ratio="1.77777"
            class=""
          >
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular
                  indeterminate
                  color="grey lighten-5"
                ></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <v-card-text class="subtitle-2 black--text">
            Referência:
            <strong
              >{{ product.provider_code }}{{ product.reference }} -
              {{ product.name }}</strong
            >
            <br />
            Material:
            <strong
              >{{ product.material_code }} - {{ product.material_name }}</strong
            >
            <br />
            Cor:
            <strong>{{ product.color_code }} - {{ product.color_name }}</strong>
            <br />
            Fornec.:
            <strong
              >{{ product.provider_code }} - {{ product.provider_name }}</strong
            >
            <br />
            <strong>{{ product.collection }}</strong>
            <br />
            <br />
            <strong v-if="showPrice" style="font-size: 22px">{{
              product.price_cif | currencyEuaToBr
            }}</strong>
          </v-card-text>
          <v-card-actions>
            <v-btn color="black" dark @click="showDetailsProduct(product)">
              <v-icon left>mdi-cart-outline</v-icon>
              Ficha Técnica
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-if="showMoreProducts">
      <v-col class="justify-center align-center items-center d-flex">
        <v-btn
          color="blue darken-2"
          dark
          class="mt-5"
          :loading="loadingShowMoreProducts"
          @click="handleClickMoreProducts"
        >
          <v-icon left>mdi-reload</v-icon>
          Carregar mais produtos
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    products: Array,
    showDetailsProduct: Function,
    marketing: {
      type: String,
      default: "N",
    },
    opportunity: {
      type: String,
      default: "N",
    },
    showPrice: {
      type: Boolean,
      default: true,
    },
    loadingShowMoreProducts: {
      type: Boolean,
      default: false,
    },
    handleClickMoreProducts: Function,
    showMoreProducts: Boolean,
  },
  data: () => ({
    ordenationOptions: [
      { value: "default", text: "Padrão" },
      { value: "news", text: "Novidades" },
      { value: "lowest-price", text: "Menor preço" },
      { value: "biggest-price", text: "Maior preço" },
    ],
    ordenation: "default",
    productColumns: 3,
    productsFilteredOrdened: [],
  }),
  created() {
    this.productsFilteredOrdened = this.filterProducts(this.products);
  },
  methods: {
    filterProducts(products) {
      let copyProducts = [...products];
      if (this.marketing === "S") {
        copyProducts = copyProducts.filter((item) => item.marketing === true);
      }
      if (this.opportunity === "S") {
        copyProducts = copyProducts.filter((item) => item.opportunity === true);
      }
      let listOrdened = this.getOrdenedProducts(copyProducts);

      return listOrdened;
    },
    getOrdenedProducts(products) {
      let data = [];
      if (this.ordenation === "news") {
        data = products.sort(
          (prev, next) => new Date(prev.created_at) - new Date(next.created_at)
        );
      } else if (this.ordenation === "biggest-price") {
        data = products.sort(
          (prev, next) =>
            parseFloat(next.price_cif) - parseFloat(prev.price_cif)
        );
      } else if (this.ordenation === "lowest-price") {
        data = products.sort(
          (prev, next) =>
            parseFloat(prev.price_cif) - parseFloat(next.price_cif)
        );
      } else {
        data = products.sort((prev, next) =>
          prev.reference.localeCompare(next.reference)
        );
      }
      return data;
    },
    handleChangeOrdenation() {
      this.productsFilteredOrdened = this.filterProducts(this.products);
    },
    getNextProducts() {
      // window.onscroll = () => {
      //   let bottomOfWindow =
      //     document.documentElement.scrollTop + window.innerHeight ===
      //     document.documentElement.offsetHeight;
      //   if (bottomOfWindow && this.showMoreProducts) {
      //     this.handleClickMoreProducts();
      //   }
      // };
    },
  },
  mounted() {
    this.getNextProducts();
  },
};
</script>
